export enum SurvicateTaskType { 
    Event = 0,
}

export enum SurvicateTaskStatus { 
    Disabled = 0,
    Enabled = 1
}

export enum OrderStatus {
    Done = 1, //Completata
    DoneWithErrors = 2, //CompletataConErrori
    Pending = 3, //Pending
    ManuallyReversed = 4, //StornataManualmente
    ToBeProcessed = 5, //DaElaborare
    ToBeVerified = 6, //PendingDaVerificare
    ManuallyRefused = 7, //RifiutataManualmente
}

export enum PaymentMethodTypeId {
    Deposit = 1,
    Withdrawal = 2
}

export enum ProviderTypeId {
    PaymentTransactions = 2 //others exist, but not needed
}

export enum BlockedProviders {
    ScratchCard = 120,
    Voucher = 159,
}